"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[985],{

/***/ 9985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ capacity_box_CapacityBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
;// CONCATENATED MODULE: ./components/widgets/capacity-box/CapacityBox.tsx




var CapacityBox = function(param) {
    var data = param.data;
    var app = (0,contexts_app/* useApp */.qD)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "Capacity-Box",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
            size: "medium",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Capacity-Box-inner",
                children: data.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "Capacity-Box-inner-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                dangerouslySetInnerHTML: {
                                    __html: item.title
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                dangerouslySetInnerHTML: {
                                    __html: item.desc
                                }
                            })
                        ]
                    }, index);
                })
            })
        })
    }));
};
/* harmony default export */ var capacity_box_CapacityBox = (CapacityBox);

;// CONCATENATED MODULE: ./components/widgets/capacity-box/index.ts



/***/ })

}]);